import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const r = e((c, a) => /* @__PURE__ */ s.jsx(
  l,
  {
    ref: a,
    ...c,
    image: (i) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...i,
        children: [
          /* @__PURE__ */ s.jsxs("g", { fill: "currentColor", clipPath: "url(#clip0_9072_2737)", children: [
            /* @__PURE__ */ s.jsx("path", { d: "M24 26c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633M24 18c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633M24 34c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633" }),
            /* @__PURE__ */ s.jsx("path", { d: "M24 26c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633M24 18c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633M24 34c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633M32 26c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633M16 26c-1.102 0-2-.898-2-2s.898-2 2-2 2 .898 2 2-.898 2-2 2m0-2.633a.63.63 0 0 0-.633.633.63.63 0 0 0 .633.633.635.635 0 0 0 .633-.633.635.635 0 0 0-.633-.633" })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_9072_2737", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "AgencyAcne5Icon";
export {
  r as AgencyAcne5Icon,
  r as default
};
//# sourceMappingURL=index.js.map
